// @flow

import * as React from 'react';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import styled from 'styled-components';
import { LabelPlacement, Color } from './types';

const SSwitch = styled(({ ...rest }) => (
  <Switch classes={{ switchBase: 'switchBase' }} {...rest} />
))`
  & .switchBase {
    height: 0px;
  }
`;

interface Props {
  label: string;
  onChange: (value: boolean) => void;
  color: Color;
  labelPlacement: LabelPlacement;
  defaultChecked?: boolean;
}

function SwitchToggle({ label, onChange, color, labelPlacement, defaultChecked }: Props) {
  function onToggle(event) {
    onChange(event.target.checked);
  }

  return (
    <FormControlLabel
      label={label}
      labelPlacement={labelPlacement}
      control={
        <SSwitch
          color={color}
          onChange={onToggle}
          defaultChecked={defaultChecked}
        />
      }
    />
  );
}

SwitchToggle.defaultProps = {
  labelPlacement: 'end',
  color: 'default',
};

export default SwitchToggle;



// WEBPACK FOOTER //
// ./src/common/components/ui/SwitchToggle.js